'use client';
import { Typography } from '@curology/ui-components-web/react';
import React from 'react';

import { type ExpressCurologySignUpSkinPdpSourceConfigType } from '../types';
import { getFormattedPrice, getNextBoxTotals } from '../utils';

export const NextBoxPricing = ({
  bundleConfig,
  selectedAddOnProductItemIds,
}: {
  bundleConfig: ExpressCurologySignUpSkinPdpSourceConfigType;
  selectedAddOnProductItemIds: number[];
}) => {
  const { nextBoxTotal, nextBoxTotalPerMonth } = getNextBoxTotals(
    bundleConfig,
    selectedAddOnProductItemIds,
  );

  return (
    <Typography size="meta">
      After your trial ends, we’ll automatically send you full-size products
      every 60 days for {getFormattedPrice(nextBoxTotal)} (subject to change).
      That breaks down to just {getFormattedPrice(nextBoxTotalPerMonth)}/month.
      Cancel anytime.
    </Typography>
  );
};
